const UnLockedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
    >
      <path
        d="M11.5977 4.5V6H14.5977V16H0.597656V6H9.59766V4.5C9.59766 2.03125 11.5977 0 14.0977 0C16.5664 0 18.5977 2.03125 18.5977 4.5V7H16.5977V4.5C16.5977 3.125 15.4727 2 14.0977 2C12.6914 2 11.5977 3.125 11.5977 4.5Z"
        fill="#33E003"
      />
    </svg>
  );
};

export default UnLockedIcon;
